(() => {
  const emit = (name, detail = {}) => {
    window.dispatchEvent(new CustomEvent(`sanct:${name}`, { detail }));
  };

  const hero = document.querySelector("[data-sanct-hero]");
  const video = hero?.querySelector("video");
  const motionControl = hero?.querySelector("[data-motion-control]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const setMotionButton = (isPaused) => {
    if (!motionControl) return;
    motionControl.setAttribute("aria-pressed", String(isPaused));
    motionControl.setAttribute("aria-label", isPaused ? "Play background video" : "Pause background video");

    const label = motionControl.querySelector("[data-motion-label]");
    if (label) label.textContent = isPaused ? "Play background video" : "Pause background video";

    const icon = motionControl.querySelector("[data-motion-icon]");
    if (icon) {
      icon.innerHTML = isPaused
        ? '<svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor" aria-hidden="true"><path d="M3 2.2v11.6L13 8 3 2.2z"></path></svg>'
        : '<svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor" aria-hidden="true"><rect x="3" y="2" width="3" height="12"></rect><rect x="10" y="2" width="3" height="12"></rect></svg>';
    }
  };

  if (video) {
    if (reduceMotion.matches) {
      video.pause();
      setMotionButton(true);
    }

    motionControl?.addEventListener("click", () => {
      if (video.paused) {
        video.play().then(() => setMotionButton(false)).catch(() => setMotionButton(true));
      } else {
        video.pause();
        setMotionButton(true);
      }
    });

    reduceMotion.addEventListener("change", (event) => {
      if (event.matches) {
        video.pause();
        setMotionButton(true);
      }
    });
  }

  const form = document.querySelector("[data-early-view-form]");
  const formSection = document.querySelector("#contact-capture");

  if (form && formSection) {
    let formViewed = false;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!formViewed && entries.some((entry) => entry.isIntersecting)) {
          formViewed = true;
          emit("early-view-form-view");
          observer.disconnect();
        }
      },
      { threshold: 0.35 },
    );
    observer.observe(formSection);

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const emailInput = form.elements.namedItem("email");
      const companyInput = form.elements.namedItem("company");
      const submitButton = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');

      if (!(emailInput instanceof HTMLInputElement) || !emailInput.checkValidity()) {
        emailInput?.reportValidity?.();
        return;
      }

      if (!(submitButton instanceof HTMLButtonElement) || !(status instanceof HTMLElement)) return;

      const defaultLabel = submitButton.dataset.defaultLabel || "join";
      const loadingLabel = form.dataset.loadingLabel || "joining";

      form.dataset.state = "submitting";
      submitButton.disabled = true;
      submitButton.textContent = loadingLabel;
      status.textContent = "";
      emit("early-view-submit");

      try {
        const response = await fetch(form.dataset.endpoint, {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({
            email: emailInput.value,
            company: companyInput instanceof HTMLInputElement ? companyInput.value : "",
            source: form.dataset.source || "shopify-v0",
            pageUrl: window.location.href,
            referrer: document.referrer,
            consentText: form.dataset.consentText,
            consentVersion: form.dataset.consentVersion,
          }),
        });

        const result = await response.json().catch(() => null);
        if (!response.ok || result?.ok !== true) throw new Error("Early View request failed");

        if (result.registration === "created") {
          window.Shopify?.analytics?.publish?.("sanct:early_view_registered", {});
        }

        form.dataset.state = "success";
        status.textContent = form.dataset.successMessage || "You are on the early view list.";
        emailInput.value = "";
        if (companyInput instanceof HTMLInputElement) companyInput.value = "";
        emit("early-view-success");
      } catch {
        form.dataset.state = "error";
        status.textContent = form.dataset.errorMessage || "Please check your email and try again.";
        emit("early-view-error");
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = defaultLabel;
      }
    });
  }

  document.querySelectorAll("[data-instagram-link]").forEach((link) => {
    link.addEventListener("click", () => emit("instagram-outbound-click"));
  });

  emit("page-view", { page: "home" });
})();
